import { yupResolver } from '@hookform/resolvers/yup';
import { useForm } from 'react-hook-form';
import { useDispatch, useSelector } from 'react-redux';
import * as Yup from 'yup';
import { vehicleActions } from '_store';
import { CustomAutocomplete } from '_components/CustomAutocomplete';
import { useEffect, useState } from 'react';

export { SettingsGeolocalisation };

/**
 * Encart lattéral settings spécifique à la page géolocalisation
 * Lorsqu'un bus est sélectionné, la carte est automatiquement centrée sur la position du bus
 * @param {*} param0 
 * @returns 
 */
function SettingsGeolocalisation({closeSettings}) {

    const dispatch = useDispatch();
    const vehicles = useSelector(state => state.vehicles?.list?.value);
    const [selectedVehicle, setSelectedVehicle] = useState(null)
    const showAllGeoloc = useSelector(state => state.vehicles.showAllGeoloc);

    /* Schéma de validaiton du formulaire */
    const validationSchema = Yup.object().shape({
        number: Yup.string()
            .required('VIN est nécessaire'),
    });
    const formOptions = { resolver: yupResolver(validationSchema) };

    const { reset } = useForm(formOptions);

    /**
     * Fonction appelée au moment de la sélection d'un bus dans la liste déroulante
     * @param {*} number 
     * @returns 
     */
    function localise(number) {
        setSelectedVehicle(number)
        const vehicle = vehicles?.find(x => x.number === number);
        dispatch(vehicleActions.setShowAllVehicles(false))
        return dispatch(vehicleActions.setVehicle(vehicle));
    }

    /**
     * Réinitialisation du champs et recentrage de la carte sur l'usine
     * @returns 
     */
    function resetFields() {
        reset({ number: '' });
        setSelectedVehicle(null)
        dispatch(vehicleActions.setVehicle(null));
    }

    useEffect(() => {
        if(showAllGeoloc){
            resetFields()
        }
    }, [showAllGeoloc])

    return (
        <div className='settings-content'> 
            <div className="settings-title">
                <span>Géolocalisation</span>
            </div>
            <div className="settings-info">Sélectionnez ou saisissez un numéro VIN / Production pour visualiser le véhicule sur la carte</div>
            <div className="settings-selection">    
                <CustomAutocomplete
                    name="number"
                    label="Numéro VIN / Production"
                    options={(vehicles ?? []).map((option) => option.number)}
                    noOptionsText="Aucune correspondance"
                    onInputChange={() => false}
                    onChange={localise}
                    onClear={resetFields}
                    value={selectedVehicle}
                />   
            </div>
        </div>
    )
}
